import { useContext } from 'react';
import PortfolioItemContext from '@/components/ChallengePortfolio/NormalView/portfolio-item/PortfolioItemContext';
import useApi from '@/lib/api/useApi';
import {
  type SetComplexImmerStateAction,
  type Task,
  type TaskSummary,
  type UserSummary,
} from '@/lib/types';

const useAddAssignee = (): ((user: UserSummary) => Promise<void>) => {
  const api = useApi();

  const {
    setPortfolioItem: setTask,
    setPortfolioItemSummary: setTaskSummary,
    portfolioItemApiEndpoint: taskApiEndpoint,
  } = useContext(PortfolioItemContext) as {
    setPortfolioItem: SetComplexImmerStateAction<Task>;
    setPortfolioItemSummary: SetComplexImmerStateAction<TaskSummary>;
    portfolioItemApiEndpoint: string;
  };

  const addAssignee = async (user: UserSummary): Promise<void> => {
    const addedAssignee = await api.post<UserSummary>(
      `${taskApiEndpoint}/assignees/add`,
      {
        email: user.email,
      },
    );

    setTask(task => {
      task.assigneesCount++;
      task.assignees.push(addedAssignee);
    });

    setTaskSummary(taskSummary => {
      taskSummary.assignees.push(addedAssignee);
    });
  };

  return addAssignee;
};

export default useAddAssignee;
